import 'css-chunk:src/app/containers/Home/UsersView/UserDetailView/UserClients.scss';export default {
  "UserClients": "_UserClients_1hm49_1",
  "text": "_text_1hm49_1",
  "table": "_table_1hm49_5",
  "nameCell": "_nameCell_1hm49_5"
};